import { render, staticRenderFns } from "./twoDimensionalProgramme.vue?vue&type=template&id=11e16131&scoped=true"
import script from "./twoDimensionalProgramme.vue?vue&type=script&lang=js"
export * from "./twoDimensionalProgramme.vue?vue&type=script&lang=js"
import style0 from "./twoDimensionalProgramme.vue?vue&type=style&index=0&id=11e16131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e16131",
  null
  
)

export default component.exports